import i18n from 'i18next';

export const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString(i18n.language, {
        day: "numeric",
        month: "short",
        year: "numeric"
    });
};